export const fundingPrograms: TableModule = {
    name: "fundingPrograms",
    route: "spa.basedata.fundingPrograms",
    defaultOrder: {
        column: "customOrderSortByParent",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "short_name",
            sortable: true
        },
        {
            name: "is_active",
            sortable: true
        }
    ],
    filters: [
        {
            name: "name",
            column: "search",
            type: "string"
        }, {
            name: "parentFundingProgram",
            column: "parent_funding_program_id",
            type: "select",
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.basedata.fundingPrograms.index'), {
                    params: {
                        filter: [{
                            column: "parent_funding_program_id",
                            operator: "isNull",
                            value: "null"
                        }]
                    }
                }).then(response => response.data?.map(
                    fundingProgram => ({
                        value: fundingProgram.id,
                        label: fundingProgram.name
                    })
                )),
            reduced: true,
        }
    ],
    tools: [
        {
            name: "fundingPrograms.create",
            isCreateAction: true,
            ability: [
                "create",
                "fundingPrograms"
            ]
        }
    ]
}